//stock market actions
export const GET_ALL_STOCKS = 'GET_ALL_STOCKS';
export const GET_ONE_STOCK = 'GET_ONE_STOCK';
export const SORT_STOCKS_BY_FIELD = 'SORT_STOCKS_BY_FIELD';

//purchasing stock actions
export const GET_ALL_PURCHASED = 'GET_ALL_PURCHASED';
export const GET_ONE_PURCHASED = 'GET_ONE_PURCHASED';
export const ADD_PURCHASED = 'ADD_PURCHASED';
export const UPDATE_PURCHASED = 'UPDATE_PURCHASED';
export const REMOVE_PURCHASED = 'REMOVE_PURCHASED';

//authentication and user actions
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const USER_INFO = 'USER_INFO';
export const USER_UPDATE_NAME = 'USER_UPDATE_NAME';
export const DELETE_USER = 'DELETE_USER';

//transactions
export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS'; 

//logs
export const GET_ALL_LOGS = 'GET_ALL_LOGS';

//error actions
export const AUTH_ERROR_OCCURRED = 'AUTH_ERROR_OCCURRED';
export const MARKET_ERROR_OCCURRED = 'MARKET_ERROR_OCCURRED';
export const PURCHASED_ERROR_OCCURRED = 'PURCHASED_ERROR_OCCURRED';
export const USER_ERROR_OCCURRED = 'USER_ERROR_OCCURRED';
export const TRANSACTION_ERROR_OCCURRED = 'TRANSACTION_ERROR_OCCURRED';
export const LOG_ERROR_OCCURRED = 'LOG_ERROR_OCCURRED';
export const BLOG_ERROR_OCCURRED = 'BLOG_ERROR_OCCURRED';
export const SURVEY_ERROR_OCCURRED = 'SURVEY_ERROR_OCCURRED';

//Blogs actions
export const GET_ALL_BLOGS = 'GET_ALL_BLOGS';
export const GET_BLOG_BY_ID = 'GET_BLOG_BY_ID';
export const CREATE_BLOGS = 'CREATE_BLOGS';
export const UPDATE_BLOG = 'UPDATE_BLOG';
export const REMOVE_BLOGS = 'REMOVE_BLOGS';

//Survey actions
export const GET_SURVEY_BY_ID= 'GET_SURVEY_BY_ID';
export const CREATE_SURVEY= 'CREATE_SURVEY';
